export default __webpack_public_path__ + "static/image_06-0629bd849dda494261f4b061aa579fec.png";